import { render, staticRenderFns } from "./PaymentNotification.vue?vue&type=template&id=7794ef6a&scoped=true&"
import script from "./PaymentNotification.vue?vue&type=script&lang=js&"
export * from "./PaymentNotification.vue?vue&type=script&lang=js&"
import style0 from "./PaymentNotification.vue?vue&type=style&index=0&id=7794ef6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7794ef6a",
  null
  
)

export default component.exports